import { MODALS, useModalsStore } from "~/store/modals";

export default () => {
  const modalsStore = useModalsStore();

  const getModal = (modal: MODALS) => {
    return {
      name: modal,
      open: (clearable?: boolean, manual?: boolean) => modalsStore.open(modal, clearable, manual),
      close: () => modalsStore.close(modal),
      isOpen: computed(() => modalsStore.isOpen(modal)),
      isActive: computed(() => modalsStore.getActive() === modal),
    };
  };

  const useCatalogFiltersModal = () => getModal(MODALS.CatalogFilters);

  return {
    useCatalogFiltersModal,
  };
};
